// extracted by mini-css-extract-plugin
module.exports = {"root":"IconVerified_root__3_aRN"};